import { ConversationDetails } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatConversationById(
  accessToken: string,
  id: number,
  options?: UseQueryOptions<ConversationDetails>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-conversation", id],
    queryFn: async () => {
      const { data } = await api.getConversationById(id, accessToken);
      return data;
    },
    ...options,
  });
}
